<template>
  <div class="g-content">
    <div class="page-file">
      <div class="btns clearfix">
        <h1 class="fl">文件夹</h1>
      </div>

      <div class="right">
        <a class="m-btn mr-30" @click="goBack" v-if="showBack">
          <svg-icon icon-class="back-file" class="g-icon-upload" />&nbsp;返回上级菜单
        </a>

        <div style="line-height: 26px" :class="{'f-r':!showBack}">
          <a class="m-btn mr-30" @click="addFile">
            <svg-icon icon-class="folder" class="g-icon-upload" />&nbsp;创建文件夹
          </a>

          <el-dropdown class="upload-drop" trigger="hover">
            <el-button size="mini" type="primary" icon="el-icon-upload2" id="uploadFileId" style="border-radius: 10px !important;padding:12px 23px;margin-right: 10px">上传<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <cmp-upload ref="myUpload" :hasIcon="false" :businessType="`project`" :callEveryFun="uploadCallback" :conacat="false"></cmp-upload>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-upload class="upload-demo" ref="upload" action="#" :http-request="upload" :before-upload="beforeUpload" :on-change="handleChange" :show-file-list="false" :file-list="fileList" multiple>
                  <a class="m-btn">
                    上传文件夹
                  </a>
                </el-upload>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 上传 -->

        </div>
      </div>

      <el-table ref="multipleTable" v-loading="listLoading" :data="dataList" stripe style="width: 100%" @selection-change="handleSelectionChange" @row-click="rowClick">
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column>-->

        <el-table-column label="名称" min-width="12%">
          <div slot-scope="scope" style="position:relative;" @click="showImg(scope.row)">
            <div style="position: absolute;left: 0;top: 1px;">
              <svg-icon icon-class="folder" style="font-size:16px;position:relative;left:2px;" v-if="!scope.row.attFileTypeStr" />
              <span v-else>
                <viewer v-if="scope.row.attFileType == 1" :options="{ url: 'data-maxUrl' }">
                  <img style="width: 20px;height: 24px" :src="scope.row.attPath || ''" :data-maxUrl="scope.row.attPath" alt :onerror="defaultImg">
                </viewer>
                <svg-icon :icon-class="'file-'+scope.row.attFileTypeStr" class="g-icon-upload" v-else />
              </span>

            </div>
            <p style="padding-left: 20px;">&nbsp;{{ scope.row.attName | ellSplit(50) }}</p>
          </div>
        </el-table-column>

        <el-table-column label="大小" min-width="8%">
          <template slot-scope="scope">{{ scope.row.size || '-' }}</template>
        </el-table-column>

        <el-table-column prop="createrName" label="创建者" min-width="8%">
          <!-- show-overflow-tooltip -->
        </el-table-column>

        <el-table-column label="更新时间" min-width="8%">
          <template slot-scope="scope">{{ scope.row.updateDate }}</template>
        </el-table-column>

        <el-table-column label="操作" min-width="12%">
          <div slot-scope="scope">
            <a class="btn-opera m-btn mr-10" @click.stop="downLoad(scope.row)">下载</a>
            <!-- <a class="btn-opera m-btn mr-10" @click="upload(scope.row)">上传</a> -->
            <a class="btn-opera m-btn mr-10" v-if="!scope.row.attFileTypeStr">
              <cmp-upload :businessType="`project`" :callEveryFun="uploadCallback" :hasIcon="false" :conacat="false" :selfData="scope.row"></cmp-upload>
            </a>
            <a href="javascript:;" class="btn-opera m-btn mr-10" icon="el-icon-edit" @click.stop="move(scope.row)">移动</a>
            <a class="btn-opera m-btn mr-10" @click.stop="addFile(scope.row, '重命名文件夹')">重命名</a>
            <a class="btn-opera m-btn mr-10 dele" @click.stop="deleItem(scope.row)">删除</a>
          </div>
        </el-table-column>
      </el-table>

      <cmp-file-move ref="fileDialog" @refresh="getDataList"></cmp-file-move>
      <!-- <cmp-footer></cmp-footer> -->
    </div>
  </div>
</template>

<script>
// import cmpFooter from '@cmp/footer'
import cmpUpload from '@cmp/my-upload/index'
import cmpFileMove from './dialog/dialog-file-move'
import axios from 'axios'
export default {
  components: {
    // cmpFooter,
    cmpUpload,
    cmpFileMove,
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      showBack: this.$route.query.fileId ? true : false,
      listLoading: true,
      dataList: [],
      fileList: [],
      filesLength: 0,
      multipleSelection: [],
      topProList: [],
      itemData: {},
      configData: {
        projectId: this.$route.query.projectId
      }
    }
  },
  watch: {
    $route() {
      this.showBack = this.$route.query.fileId ? true : false
      // this.$refs.myUpload.clearFileList()
      this.getDataList()
    }
  },
  methods: {
    // 項目列表
    getProList() {
      this.$http1.get('/project/getProjectList', {})
        .then(res => {
          if (res.success) {
            this.topProList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //通过onchanne触发方法获得文件列表
    handleChange(file, fileList) {
      this.fileList = fileList;
    },

    beforeUpload(file) {
      this.filesLength += 1
    },


    upload({ file }) {
      this.listLoading = true
      let tempArr = [], _this = this
      let fd = new FormData()
      fd.append("projectId", this.$route.query.projectId);
      fd.append("parentId", this.$route.query.fileId || "");
      fd.append('files', file);
      this.$http1.post('projectFile/uploadFiles', fd).then(result => {
        if (result.success) {
        } else {
          _this.$message.error(result.message)
        }
        if (_this.filesLength === 1) {
          this.listLoading = false
          // 本次所有的文件均已上传完毕
          _this.$message.success(`上传完毕`)
          _this.getDataList()
        }
        _this.filesLength--

      })
    },
    showImg(obj) {
      console.log(obj)
    },
    getDataList() {
      this.listLoading = true
      this.$http1
        .post('/projectFile/getProjectFileList', {
          projectId: this.$route.query.projectId,
          parentId: this.$route.query.fileId
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 勾选复选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 点击某行
    rowClick(row, column, event) {
      // 是否为文件
      if (row.attFileTypeStr) {
        return
      }
      // 是否为上传
      if (
        event.target.type === 'file' ||
        event.srcElement.innerText.trim() === '上传'
      ) {
        return
      }
      this.$router.push({
        path: '/project/sub',
        query: {
          type: 'file',
          projectName: this.$route.query.projectName,
          projectId: this.$route.query.projectId,
          projectType: this.$route.query.projectType,

          fileId: row.fileId
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    // 创建文件夹
    addFile(item, title) {
      let strName = '',
        arr = ''
      // 文件类型(0:文件,1:文件夹)
      if (title && item.type === '0') {
        // title = title.split('.')
        arr = item.attName.split('.')
        arr.pop()
        strName = arr.join('.')
      } else {
        strName = item.attName
      }
      this.$prompt('', title || '创建文件夹', {
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
        inputValue: strName || null,
        inputPlaceholder: '文件夹名称',
        // inputPattern: /^[\S]{1,50}$/,
        inputPattern: /^.{1,50}$/,
        inputErrorMessage: '请输入1到50位字符'
        // center: true
      })
        .then(({ value }) => {
          if (strName) {
            this.modifyRemote(item, value)
          } else {
            this.addRemote(item, value)
          }
        })
        .catch(() => { })
    },
    // 新建分组请求
    addRemote(item, value) {
      this.$http1
        .post('/projectFile/addFiles', {
          projectId: this.$route.query.projectId, //	项目ID
          attachmentId: value, //	文件夹名称
          parentId: this.$route.query.fileId, //	父级ID
          type: '1' //	文件类型(0:文件，1文件夹)
        })
        .then(res => {
          if (res.success) {
            this.$message.success('新建文件夹成功')
            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 重命名文件夹
    modifyRemote(item, value) {
      // 文件类型(0:文件,1:文件夹)
      this.$http1
        .post('/projectFile/reNameProjectFile', {
          fileId: item.fileId, //	文件id
          ext1: value //	文件新名称
        })
        .then(res => {
          if (res.success) {
            this.$message.success(
              item.type === '1' ? '重命名文件夹成功' : '重命名文件成功'
            )
            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 下载
    downLoad(item) {
      location.href =
        '/singleMuseum/projectFile/downloadProjectFile?fileId=' + item.fileId
    },
    // 上传回调 文件新增
    uploadCallback(item, row) {
      // 是否为文件夾上传
      // row.fileId
      this.$http1
        .post('/projectFile/addFiles', {
          projectId: this.$route.query.projectId, //	项目ID
          attachmentId: item.attId, //	文件夹名称
          parentId: row.fileId ? row.fileId : this.$route.query.fileId, //	父级ID
          type: '0' //	文件类型(0:文件，1文件夹)
        })
        .then(res => {
          if (res.success) {
            !row.fileId && this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 移动
    move(item) {
      this.$refs.fileDialog.init(item)
    },
    // 删除
    deleItem(item) {
      this.$common.confirm(
        {
          title: '删除文件',
          content: '所有内容将无法找回，请谨慎操作'
        },
        () => {
          this.$http1
            .post('/projectFile/deleteProjectFile', {
              fileId: item.fileId
            })
            .then(res => {
              if (res.success) {
                this.$message.success('删除成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    }
  },
  created() {
    this.getProList()
    this.getDataList()
    this.$nextTick(() => {
      this.$refs.upload.$children[0].$refs.input.webkitdirectory = true
    })
  }
}
</script>

<style lang="scss" scoped>
.btn-opera.dele {
  color: $danger;
}
::v-deep .el-table__row {
  cursor: pointer;
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .f-r {
    width: 100%;
    text-align: right;
  }
}
</style>


